// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"7bf0407e","174":"733555be","376":"3ce7cbc5","400":"ae4b24fa","506":"e37421a4","540":"9fa65c0a","953":"c800fcb2","962":"562173e8","980":"30e1db13"}[chunkId] + ".chunk.js";
};